import { render, staticRenderFns } from "./RolesDboTab.vue?vue&type=template&id=7748433a&scoped=true&lang=pug"
import script from "./RolesDboTab.vue?vue&type=script&lang=js"
export * from "./RolesDboTab.vue?vue&type=script&lang=js"
import style0 from "./RolesDboTab.vue?vue&type=style&index=0&id=7748433a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7748433a",
  null
  
)

export default component.exports